package com.partejar.app.feature.modeloscontrato.data.remote
import com.partejar.app.feature.modeloscontrato.data.*
class ModelosContratoRemoteMapper {
    fun model(dto: ModeloContratoDto) = ModeloContrato(dto.modeloContratoId, dto.nome, dto.ativo, dto.numeroVersao, dto.conteudoTemplate)
    fun variable(dto: TemplateVariableDto) = TemplateVariable(dto.grupo, dto.rotulo, dto.placeholder)
}
